import { render, staticRenderFns } from "./FrzChamberPalletDispatch.vue?vue&type=template&id=6470a927"
import script from "./FrzChamberPalletDispatch.vue?vue&type=script&lang=js"
export * from "./FrzChamberPalletDispatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports